import React, { useEffect, useState } from "react";
import axios from "axios";
import Constant from "../Components/Utils/Constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function CreateAdminsForm({ onClose }) {
  const [isVisible, setIsVisible] = useState(true);
  // form states
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [createdby, setCreatedby] = useState("");
  const [userName, setUserName] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isPhoneValid, setIsPhoneValid] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    onClose();
  };

  // api
  useEffect(() => {
    const storedName = localStorage.getItem("name");

    if (storedName) {
      setUserName(storedName);
      setCreatedby(storedName);
    } else {
      setUserName("Unauthorized");
      setCreatedby("Unauthorized");
    }
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const validatePhone = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate email and phone
    const isEmailValid = validateEmail(email);
    const isPhoneValid = validatePhone(phone);
    setIsEmailValid(isEmailValid);
    setIsPhoneValid(isPhoneValid);
    // If both email and phone are valid, proceed with form submission
    if (isEmailValid && isPhoneValid) {
      try {
        const adminData = {
          email,
          name,
          phone,
          password,
          createdby,
        };
        const response = await axios.post(
          `${Constant.BASE_URL}/admin/signup`,
          adminData
        );
        if (response.status === 201) {
          handleClose();
          setEmail("");
          setName("");
          setPassword("");
          setPhone("");
          setCreatedby("");
          toast.success("Admin Created Sucessfully!")
        } else {
          console.log("Failed to submit form Status:", response.status);
          toast.error("Failed to Admin Created!")
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  return isVisible ? (
    <>
      <ToastContainer />
      <div className="popup-form">
        <div className="w-full  flex items-center justify-center">
          <div className="bg-white p-4 rounded-md shadow-md  py-3 px-1 lg:py-3 xl:py-3 2xl:p-4  ">
            <div className="lg:w-[300px] xl:w-[300px] 2xl:w-[400px] items-center justify-center">
              <div className="text-lg font-semibold text-center mb-4 2xl:text-4xl ">
                Create Admin
              </div>
              <hr className="mt-1 " />

              <form onSubmit={handleSubmit}>
                <div className="flex flex-col justify-center items-center">
                  <div className="lg:py-5 xl:py-5 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                    <div className="flex py-3 justify-end items-center">
                      <label
                        htmlFor="yourInput"
                        className="flex items-end px-3"
                      >
                        Name:<span className="text-red-500 ml-1">*</span>
                      </label>
                      <input
                        type="text"
                        id="yourInput"
                        className="border-b border-gray-500 outline-none flex items-start mb-2"
                        style={{ width: "163px", textAlign: "center" }}
                        placeholder="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="flex py-3 justify-end items-center">
                      <label
                        htmlFor="yourInput"
                        className="flex items-end px-3"
                      >
                        Phone :<span className="text-red-500 ml-1">*</span>
                      </label>
                      <div className="flex flex-col">
                        <input
                          type="tel"
                          id="yourInput"
                          className="border-b border-gray-500 outline-none flex items-start mb-2"
                          style={{ width: "163px", textAlign: "center" }}
                          placeholder="number"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          required
                        />
                        {!isPhoneValid && (
                          <p className="text-red-500">
                            Invalid phone format (10 digits)
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="flex py-3 justify-end items-center">
                      <label
                        htmlFor="yourInput"
                        className="flex items-end px-3"
                      >
                        Email :<span className="text-red-500 ml-1">*</span>
                      </label>
                      <div className="flex flex-col">
                        <input
                          type="text"
                          id="yourInput"
                          className="border-b border-gray-500 outline-none flex items-start mb-2"
                          style={{ width: "163px", textAlign: "center" }}
                          placeholder="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                        {!isEmailValid && (
                          <p className="text-red-500 ml-1">
                            Invalid email format
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="flex py-3 justify-end items-center">
                      <label
                        htmlFor="yourInput"
                        className="flex items-end px-3"
                      >
                        Password :<span className="text-red-500 ml-1">*</span>
                      </label>
                      <input
                        type="text"
                        id="yourInput"
                        className="border-b border-gray-500 outline-none flex items-start mb-2"
                        style={{ width: "163px", textAlign: "center" }}
                        placeholder="........."
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>

                    <div className="flex py-3 justify-end items-center">
                      <label
                        htmlFor="yourInput"
                        className="flex items-end px-3"
                      >
                        Created By :
                      </label>
                      <input
                        type="text"
                        id="yourInput"
                        className="text-[#BBB] border-b border-gray-500 outline-none flex items-start mb-2"
                        style={{ width: "163px", textAlign: "center" }}
                        placeholder="Super Admin (Auto)"
                        value={userName}
                        onChange={(e) => setCreatedby(e.target.userName)}
                        required
                      />
                    </div>
                  </div>
                  <div className="  flex justify-center p-1 space-x-12 mt-8 pb-5">
                    <button
                      type="button"
                      onClick={handleClose}
                      className="loginbtn text bg-white w-16 flex-shrink-0 shadow-md rounded-sm"
                      style={{
                        boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="loginbtn  text w-16 flex-shrink-0 bg-custom-gradient rounded-sm"
                      style={{
                        background:
                          "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                      }}
                    >
                      Create
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : null;
}